/** Suprisingly non-trivial due to undetected type errors and floating-point magic
 *
 * e.g. 4.85 * 100 != 485
 * @param amount
 * @returns
 */
// Number(4.85)*100 != 485
const convertUSDToCents = (amount: number | string) => Math.round(Number(amount) * 100)

export { convertUSDToCents as convertUSDToCents }

const currencyDecimalMap: Record<string, number> = {
  JPY: 0,
  KRW: 0,
  IDR: 0,
  VND: 0,
  PYG: 0,
  COP: 0,
  ISK: 0,
  MGA: 0,
}

export const getCurrencyDecimalPlaces = (currencyCode: string): number => {
  return currencyDecimalMap[currencyCode.toUpperCase()] ?? 2
}
